import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { Button } from '@ami/react/core';

export default class ReviewQuoteProductUseLatestDiscountsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
    };
  }

  static propTypes = {
    onChanged: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired
  };

  hide = () => this.props.onHide();

  save = () => {
    this.setState({ saving: true });
    this.props.onChanged(true);
    this.hide();
    this.setState({ saving: false });
  };

  render() {
    const { show } = this.props;
    if (!show) return null;

    return (
      <SimpleModal show={show}>
        <ModalHeader title="Use Latest Discounts" />
        <ModalBody>
          <form className="container">
            <div className="row">
              <div className="col">
                <p>{`Do you want to allow the system to use the current set of discounts when calculating pricing for all products on this quote?`}</p>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <Button
            label="Continue"
            className="btn btn-primary"
            onClick={this.save}
            showSpinner={this.state.saving}
            disabled={this.state.saving}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
